/* unplugin-vue-components disabled */import script from "./classMes_copy.vue?vue&type=script&setup=true&lang=js"
export * from "./classMes_copy.vue?vue&type=script&setup=true&lang=js"

import "./classMes_copy.vue?vue&type=style&index=0&id=5a198002&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a198002"]])

export default __exports__